module.exports = __webpack_public_path__ + "app/principal/widgets/invoice-section-3wZsapWO.html";